import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';

import type { Service, SortOrderDirection } from 'webapp-types';
import { MetricLibrarySortBy, OrderDirection, TemplateObjectType } from 'webapp/enums/enums';
import { TrackingEvent } from 'webapp/enums/tracking';
import type { SearchProps } from 'webapp/utils/filter';

import type { FilterSortSettings } from 'webapp/models-custom/filter-sort/base';
import FilterSort from 'webapp/models-custom/filter-sort/base';
import type Template from 'webapp/models-custom/template';

export default class FilterSortMetricLibrarySourceTemplates extends FilterSort<Template> {
	@service('model-manager/source-types')
	declare mmSourceTypesService: Service.ModelManager.SourceTypes;

	@tracked override sortProp = 'usedCount';
	@tracked override sortOrder: SortOrderDirection = OrderDirection.ASC;

	override itemDomSelector = 'li.filter-sort-item';

	override searchProps: SearchProps = {
		title: 5,
		keywords: 3,
		description: 2,
		metricsNames: 1,
	};

	override typedFilterEventName = TrackingEvent.TEMPLATE_SEARCH;

	constructor(options: FilterSortSettings<Template>, searchPlaceholder?: string) {
		super(options);

		if (searchPlaceholder) {
			this.searchPlaceholder = searchPlaceholder;
		}

		const selectedFilters = this.readSavedSelectedFilters();
		if (selectedFilters[1]) {
			const selected = selectedFilters[1][0] as MetricLibrarySortBy;
			this.onSortFilterChange(selected);
		}

		if (this.allItems.length) {
			this.typedFilterEventData = {
				objectType:
					this.allItems[0]!.objectType === TemplateObjectType.BOARD
						? 'databoard'
						: 'report',
			};
		}

		this.createFilter({
			id: 1,
			label: 'Sort by',
			name: 'sort',
			selected: selectedFilters[1],
			stringValues: true,
			isSort: true,
			getOptions: () => {
				return this.sortByOptions;
			},
			onSelectedChange: (filter) => {
				const selected = filter.selected[0] as MetricLibrarySortBy;
				this.onSortFilterChange(selected);
			},
		});
	}

	get sortByOptions() {
		return Object.values(MetricLibrarySortBy).map((sort) => ({
			id: sort,
			text: sort,
		}));
	}

	override get isAnyFilterActive(): boolean {
		return this.filters.some((f) => (f.isSort ? false : f.isActive));
	}

	override resetFilters(): void {
		this.filters.forEach((f) => {
			if (f.isSort) {
				f.selectOption(f.options[0]!.id);
			} else {
				f.selectOption(f.defaultValue);
			}
		});
	}

	override updateSortBy(sortBy: MetricLibrarySortBy): void {
		switch (sortBy) {
			default:
			case MetricLibrarySortBy.POPULARITY:
				this.sortProp = 'usedCount';
				break;
			case MetricLibrarySortBy.ALPHABETICALLY: {
				this.sortProp = 'title';
				break;
			}
		}
	}
}
